<template>
  <div id="dropdown-form" class="pb-3" v-if="question && question.is_enabled">
    <b-form-group v-if="content && content.visible">
      <template slot="label">
        <div class="question-title mb-2">
          {{ question.question }}
          <sup class="text-danger font-weight-bold" v-if="content.required">
            *
          </sup>
        </div>
        <div>
            <ImageRender
              v-if="question.image"
              :imgBase64="question.image" :showCloseButton="false"/>
        </div>
      </template>
      <b-container>
        <b-row>
          <b-col
            :cols="content.attributes.width === 'full' ? '12' : '6'"
            class="select-container mb-2"
          >
            <b-form-select
              v-model="answers[question.question]"
              :value="
                (answers[question.question] = answers[question.question]
                  ? answers[question.question]
                  : '')
              "
            >
              <option disabled :value="''">Please select an answer</option>
              <option
                v-for="(option, key) in content.attributes.options"
                :key="key"
                :value="option.answer"
              >
                {{ option.answer }}
              </option>
            </b-form-select>
            <b-form-invalid-feedback :state="isInvalid(question.question)">
              {{ errorMessage(question.question) }}
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-container>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageRender from "../../../components/ImageRender.vue";
export default {
  name: "Dropdown",
  components: {
    ImageRender,
  },
  props: ["question", "answers"],
  data() {
    return {
      content: null,
    };
  },
  methods: {
    isInvalid(field) {
      if (this.errors === null) {
        return null;
      } else {
        return !Object.keys(this.errors).includes(field)
          ? null
          : !Object.keys(this.errors).includes(field);
      }
    },
    errorMessage(field) {
      if (this.errors === null) {
        return "";
      } else if (Object.keys(this.errors).includes(field)) {
        return Array.isArray(this.errors[field])
          ? this.errors[field].join(" ")
          : this.errors[field];
      }
    },
  },
  computed: {
    ...mapGetters("survey", ["errors"]),
  },
  watch: {
    question() {
      if (this.question.contents.length) this.content = this.question.contents[0];
    }
  },
  created() {
    if (this.question.contents.length) this.content = this.question.contents[0];
  },
};
</script>

<style>
.select-container{
  padding-right: 0;
}
</style>